var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFeatherCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 99 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .a,\r\n            .b,\r\n            .d {\r\n                fill: none;\r\n            }\r\n\r\n            .a,\r\n            .b {\r\n                stroke: #fff;\r\n                stroke-linecap: round;\r\n                stroke-width: 4px;\r\n            }\r\n\r\n            .a {\r\n                stroke-linejoin: round;\r\n            }\r\n\r\n            .b {\r\n                stroke-dasharray: 231;\r\n            }\r\n\r\n            .c {\r\n                stroke: none;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.796 0.121)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.514,6,27.349,52.211,13.5,38.362",
    transform: "translate(21.377 5.974)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(94.204 3.879) rotate(90)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 45,
    cy: 45.5,
    rx: 45,
    ry: 45.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 45,
    cy: 45.5,
    rx: 47,
    ry: 47.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherCheckCircle);
export default __webpack_public_path__ + "static/media/Icon_feather_check_circle.a8b88180.svg";
export { ForwardRef as ReactComponent };